import React, { useEffect, useState } from "react";
import LogoCEA from "../assets/images/logo.png";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import SyncLoader from "react-spinners/SyncLoader";

const CancelRegistration = () => {
  const navigate = useNavigate();
  const { orderId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [summary, setSummary] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const [cancelling, setCancelling] = useState(false);
  const [done, setDone] = useState(false);

  // Path backend sengaja "/api/cancel-registration" (beda dari path halaman
  // ini sendiri, "/cancel-registration") — lihat komentar di CancelRegistrationRoute.js.
  useEffect(() => {
    axios.get(`/api/cancel-registration/${orderId}`)
      .then((res) => setSummary(res.data))
      .catch((err) => setErrorMsg(err.response?.data?.msg || "This cancellation link is no longer valid."))
      .finally(() => setIsLoading(false));
  }, [orderId]);

  const handleCancel = async () => {
    const result = await Swal.fire({
      text: "Are you sure you want to cancel this registration? This cannot be undone.",
      icon: "warning",
      background: "white",
      color: "black",
      showCancelButton: true,
      confirmButtonColor: "#fb3104",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, cancel it",
    });
    if (!result.isConfirmed) return;

    setCancelling(true);
    try {
      await axios.post(`/api/cancel-registration/${orderId}`);
      setDone(true);
    } catch (err) {
      Swal.fire({
        text: err.response?.data?.msg || "Failed to cancel this registration.",
        icon: "error",
        background: "white",
        color: "black",
        confirmButtonColor: "#fb3104",
      });
    } finally {
      setCancelling(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f4f4f4", display: "flex", justifyContent: "center", alignItems: "center", padding: "40px 16px" }}>
      <div style={{ backgroundColor: "#fff", borderRadius: "12px", padding: "40px", width: "100%", maxWidth: "480px", boxShadow: "0 4px 16px rgba(0,0,0,0.1)", textAlign: "center" }}>
        <img src={LogoCEA} alt="CEA Logo" style={{ width: "64px", height: "64px", objectFit: "contain", marginBottom: "12px" }} />
        <h4 style={{ fontWeight: "700", color: "#fb3104", marginBottom: "20px" }}>Cancel Registration</h4>

        {isLoading ? (
          <div style={{ padding: "20px 0" }}>
            <SyncLoader color="#fb3104" size={10} />
          </div>
        ) : done ? (
          <>
            <p style={{ color: "#28a745", fontWeight: "600", fontSize: "15px" }}>
              Your registration has been cancelled. No payment will be charged.
            </p>
            <button
              type="button"
              onClick={() => navigate("/")}
              style={{ marginTop: "12px", padding: "10px 24px", backgroundColor: "#fb3104", color: "#fff", border: "none", borderRadius: "8px", fontWeight: "700", fontSize: "14px", cursor: "pointer" }}
            >
              Back to Homepage
            </button>
          </>
        ) : errorMsg || !summary ? (
          <>
            <p style={{ color: "#888", fontSize: "14px" }}>{errorMsg}</p>
            <button
              type="button"
              onClick={() => navigate("/")}
              style={{ marginTop: "12px", padding: "10px 24px", backgroundColor: "transparent", color: "#888", border: "1px solid #ddd", borderRadius: "8px", fontWeight: "600", fontSize: "14px", cursor: "pointer" }}
            >
              Back to Homepage
            </button>
          </>
        ) : (
          <>
            <p style={{ color: "#444", fontSize: "15px", marginBottom: "6px" }}>
              You're about to cancel the pending payment/registration for:
            </p>
            <p style={{ fontWeight: "700", fontSize: "17px", margin: "0 0 4px" }}>{summary.title}</p>
            <p style={{ color: "#666", fontSize: "14px", marginBottom: "24px" }}>{summary.subtitle}</p>
            <p style={{ fontSize: "13px", color: "#999", marginBottom: "24px" }}>
              This will void the payment link sent to you — no charge will be made, and this registration will no longer be processed.
            </p>
            <button
              type="button"
              onClick={handleCancel}
              disabled={cancelling}
              style={{ width: "100%", padding: "10px", backgroundColor: "#fb3104", color: "#fff", border: "none", borderRadius: "8px", fontWeight: "700", fontSize: "15px", cursor: cancelling ? "not-allowed" : "pointer", opacity: cancelling ? 0.7 : 1 }}
            >
              {cancelling ? "Cancelling..." : "Yes, Cancel This Registration"}
            </button>
            <button
              type="button"
              onClick={() => navigate("/")}
              disabled={cancelling}
              style={{ width: "100%", marginTop: "10px", padding: "10px", backgroundColor: "transparent", color: "#888", border: "1px solid #ddd", borderRadius: "8px", fontWeight: "600", fontSize: "14px", cursor: cancelling ? "not-allowed" : "pointer" }}
            >
              No, Keep My Registration
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default CancelRegistration;
